module.exports = __webpack_public_path__ + "static/img/200174.54152cc9.png";